/* oxlint-disable ndte/design-system-imports */

import type React from "react";

import { createCompoundComponent } from "@nephroflow/design-system/utils/component";

import * as Component from "@nephroflow/design-system/components/loading";
import { Logo } from "~/components/logo";

import { cn } from "@nephroflow/design-system/styling/utils";

export function LogoLoading({ className, ...divProps }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...divProps} className={cn("flex h-full items-center justify-center", className)}>
      <Logo className="h-12 w-12 animate-pulse" />
    </div>
  );
}

export * from "@nephroflow/design-system/components/loading";

export const Loading = createCompoundComponent("Loading", null, {
  Placeholder: Component.Loading.Placeholder,
  Spinner: Component.Loading.Spinner,
  Waiting: Component.Loading.Waiting,

  // Extra components
  Logo: LogoLoading,
});
